/**
 * jv.Common.MeetingRoomSelect Module
 * ===============================
 *
 * Render a select2 widget for selecting Meeting Rooms. Optionally toggle multiple.
 * Added an option to allow entering the email in the select2 along with the employee data
 *
 * Usage in HTML
 * -------------
 * ```
 * <input jv-meeting-room-select[="multiple"] [jv-meeting-room-select-obj] [jv-employee-select-disable-preselected] [jv-employee-select-filter=fn] data-placeholder="Select Recipients" ng-model="scheduleData.recipients" />
 * ```
 *
 * Add `jv-meeting-room-select-obj` if you want the model to contain the data object instead of the id.
 *
 * Add `jv-meeting-room-select-disable-preselected` to disable the removal of previously selected employees.
 *
 * Add `jv-meeting-room-select-filter` to provide a function that filters the results using jQuery.map.
 *
 * Add `jv-meeting-room-select-allow-clear` to show the clear button (only relevant when a placeholder is specified and not multi).
 *
 * Add 'jv-meeting-room-select-image' if you want the items design to include the profile picture.
 *
 * Multiple URL's can be set per page / module
 * -------------------------------------------
 *
 * Usage in a module (one URL per module)
 * --------------------------------------
 * angular.module('moduleNameHere', []).value('url', '../action/user/search?roleName=Recruiter')
 *
 * If neither the `jv-meeting-room-select-url` nor the `.value('url', '')` value is set, it will default to the one provided below.
 */
angular.module('jv.Common.MeetingRoomSelect', ['jv.Common.TextUtil'])

.config(['$provide', function($provide) {

    $provide.value('meetingRoomUrl', jvUrls.admin + '/action/admin/meetingRooms?');

}])

.directive('jvMeetingRoomSelect', ['$timeout', 'meetingRoomUrl', 'TextUtil', function($timeout, meetingRoomUrl, TextUtil){
    var imageFormat = function (meetingroom) {
        var imgurl = '';
        if (!meetingroom.email) {
            imgurl = jvUrls.cdn + 'thumbnails/avatar/otherlocation-default.png';
        } else {
            var firstChar = meetingroom.name && meetingroom.name.match(/^[a-z]/i) ? meetingroom.name.charAt(0).toUpperCase() : '';
            imgurl = jvUrls.cdn + 'thumbnails/avatar/'+ firstChar + '-default.png';
        }

        return '<img src=' + imgurl + ' class="img-circle">' + '<span>' + TextUtil.htmlEncode(meetingroom.name) + '</span>';
    };
    return {
        require: 'ngModel',
        link: function($scope, iElm, iAttrs, controller) {
            var params = '', // not sure what this is for
                filter = $scope.$eval(iAttrs.jvMeetingRoomFilter),
                isMultiple = (iAttrs.jvMeetingRoomSelect === 'multiple'),
                url = meetingRoomUrl,
                changed = false;

            var config = $.extend({},{
                createSearchChoice: function(term, data) {
                    if ($(data).filter(function(index) {
                        return data[index].name.toUpperCase() === term.toUpperCase();
                    }).length === 0) {
                        return {
                            EId: term,
                            email: '',
                            name: term
                        };
                    }
                },
                tokenSeparators: angular.isDefined(iAttrs.jvEmployeeSelectTokenSeparator) ? [iAttrs.jvEmployeeSelectTokenSeparator] : [','],
                id:'EId',
                multiple: isMultiple,
                allowClear: angular.isDefined(iAttrs.jvMeetingRoomSelectAllowClear),
                containerCssClass: 'enhanced-select2',
                dropdownCssClass: 'enhanced-select2',
                ajax: {
                    quietMillis: 500,
                    url: function() {
                        return url;
                    },
                    data: function (term, page) {
                        var pageSize = term && 10 || 50,
                            result = {
                                name: term,
                                pageSize: pageSize,
                                page: page - 1
                            };
                        if(angular.isFunction(params)){
                            angular.extend(result, params());
                        }else if(angular.isObject(params)){
                            angular.extend(result, params);
                        }

                        return result;
                    },
                    results: function (data) { // parse the results into the format expected by Select2 .
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        var meetingRooms = data.meetingRooms || [],
                            more = Boolean(meetingRooms.length);

                        if (angular.isFunction(filter)) {
                            meetingRooms = $.map(meetingRooms, filter);
                        }

                        return {
                            results: meetingRooms,
                            more: more
                        };
                    }
                },
                escapeMarkup: function(markup) {
                    return markup;
                },
                formatResult: imageFormat,
                formatSelection: imageFormat,
                initSelection: function(element, callback) {
                    var query, model;

                    if (typeof iAttrs.jvMeetingRoomSelectObj !== 'undefined' && !iAttrs.jvMeetingRoomSelectObj) {
                        model = $scope.$eval(iAttrs.ngModel).rooms;
                        if (angular.isObject(model)) {
                            return callback(model);
                        }
                    }
                    if (isMultiple) {
                        query = 'ids=' + element.val().split(',').join('&ids=');
                    }
                    else {
                        query = 'ids=' + element.val();
                    }
                    $.ajax({ method: 'GET', cache: false, url: url + query, success: function(data){
                        data = config.ajax.results(data).results;
                        if(typeof iAttrs.jvMeetingRoomSelectDisablePreselected !== 'undefined' && !iAttrs.jvMeetingRoomSelectDisablePreselected){
                            // add lock to the data.
                            angular.forEach(data, function(value, index){
                                value.locked = true;
                                data[index]= value;
                            });
                        }
                        if (!isMultiple) {
                            if (data.length) {
                                data = data[0];
                            }
                            else {
                                data = false;
                            }
                        }
                        callback(data);
                    }});
                }
            }, window._jvPluginDefaults.select2);

            iElm.select2(config).on('change', function(e) {
                changed = true;
                $scope.$apply(function() {
                    var val = e.val;
                    if (typeof iAttrs.jvMeetingRoomSelectObj !== 'undefined' && !iAttrs.jvMeetingRoomSelectObj) {
                        val = {
                            rooms: iElm.select2('data'),
                            added: e.added || null,
                            removed: e.removed || null
                        };
                    }
                    controller.$setViewValue(val);
                });
            });

            $scope.$watch(iAttrs.ngModel, function(meetingrooms) {
                if (!changed && ((isMultiple && meetingrooms.rooms && meetingrooms.rooms.constructor === Array && meetingrooms.rooms.length > 0) || (!isMultiple && meetingrooms.rooms)) ) {
                    iElm.select2('val', meetingrooms.rooms);
                }
                if (!meetingrooms.rooms || meetingrooms.rooms.length === 0) {
                    iElm.select2('val', '');
                }
                changed = false;
            });

            $scope.$on('$destroy', function() {
                iElm.select2('destroy');
            });
        }
    };
}]);
